import React, { useEffect, useRef } from 'react'
import { Drawer } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
    drawerPaper: {
        width: (props) => props.width,
        position: 'absolute',
        height: '100%',
        zIndex: 1,
        backgroundColor: '#ffffff',
        borderRight: '1px solid #e5e7eb',
        borderTop: '1px solid #e5e7eb',
        boxSizing: 'border-box',

    },
    backdrop: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 0,
        height: '100%', // Only cover the container height
    },
}))

export const DrawerSidebar = (props) => {

    const { open, setOpen, width = 240, variant = "temporary", children } = props
    const classes = useStyles({ width })




    return (
        <Drawer
            open={open}
            onClose={setOpen}
            anchor='left'
            variant={variant}
            classes={{
                paper: classes.drawerPaper,
            }}
            ModalProps={{

                style: {
                    position: 'absolute',
                    height: '100%'
                },
                disablePortal: true,
                BackdropProps: {
                    className: classes.backdrop,

                }
            }}
        >
            {children}
        </Drawer>
    )
}
